import { type FilterValues } from "components/filters/FilterContext";
import { mapResponseToAddressFilter, mapAddressFilterToInstruction, mapResponseToKeywordFilter, mapKeywordFilterToInstruction, mapResponseToTagFilter, mapTagFilterToInstruction, mapVenueCapacityFilterToInstruction, mapResponseToVenueCapacityFilter, mapResponseToVenueCategoryFilter, mapVenueCategoryFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.ListVenueInstruction => ({
  keyword: mapKeywordFilterToInstruction(filter.keyword),
  address: mapAddressFilterToInstruction(filter.address),
  venueCategoryIds: mapVenueCategoryFilterToInstruction(filter.venueCategory),
  venueCapacity: mapVenueCapacityFilterToInstruction(filter.venueCapacity),
  tags: mapTagFilterToInstruction(filter.tags),
  page,
  perPage,
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.ListVenueFilters,
  values: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  address: mapResponseToAddressFilter(response.address),
  venueCategory: mapResponseToVenueCategoryFilter(response.venueCategories),
  venueCapacity: mapResponseToVenueCapacityFilter(response.venueCapacity),
  tags: mapResponseToTagFilter(response.tags, values.tags)
});
